/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import { hillo } from 'hillo'
import dayjs from 'dayjs'
import { groupBy } from 'lodash-es'
import { sumBy } from 'lodash'

const entity = {
  _action: {
    form: false
  },
  eventCount: {
    form: false
  },
  extraCounter: {
    form: false
  }
}

const config = {
  load: async function (filter) {
    let [fromDateTime, toDateTime] = filter[0].dateFilter
    if (fromDateTime === toDateTime) {
      toDateTime = dayjs(toDateTime).add(1, 'day').format('YYYY-MM-DD')
    }
    const res = (await hillo.get('AccessLog.php?op=queryOperationLog', {
      fromDateTime: fromDateTime + ' 04:00:00',
      toDateTime: toDateTime + ' 03:59:59',
      descending: 1
    })).content
    res.forEach(it => {
      it._action = it.action
    })
    const dictionary = groupBy(res, 'action')
    const result = []
    for (const k in dictionary) {
      const total = sumBy(dictionary[k], (it) => {
        return parseFloat(it.extraId)
      })
      result.push({
        _action: k,
        eventCount: dictionary[k].length,
        extraCounter: total
      })
    }
    return result
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function printOperationLog (timespan, withDetail) {
  let [fromDateTime, toDateTime] = timespan
  if (fromDateTime === toDateTime) {
    toDateTime = dayjs(toDateTime).add(1, 'day').format('YYYY-MM-DD')
  }
  return hillo.post('AccessLog.php?op=printOperationLog', {
    fromDateTime: fromDateTime + ' 04:00:00',
    toDateTime: toDateTime + ' 03:59:59',
    withDetail
  })
}
